import { OnDestroy } from '@angular/core';
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { Component, OnInit, DoCheck } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { dashboardService } from '../services/dashboard/dashboard.service';
import { PubSubService } from '../service/pubSub.service';
import { BAppService } from '../service/bApp.service';
// import { homeComponent } from '../homeComponent/home.component';
/**
* Model import Example : 
* import { HERO } from '../models/hero.model.ts';
*/

@Component({
  selector: 'bh-notification',
  templateUrl: './notification.template.html'
})

export class notificationComponent implements OnInit, OnDestroy, DoCheck {
  subscribe: any = {
    ss: {
      access: false,
      channels: {}
    },
    wic: {
      access: false,
      channels: {}
    },
    cci: {
      access: false,
      channels: {}
    }
  };

  actionBarSub;
  dashboardObj;
  constructor(private r: ActivatedRoute, private mulNotify: dashboardService, private pubsub: PubSubService, private bAppService: BAppService) { }
  ngOnInit() {
    // console.log(JSON.parse(JSON.stringify(this.mulNotify.dashboardObject.dashboard)))
    this.actionBarSub = this.pubsub.$sub('saveNot', (eventObject) => {
      if (eventObject == 'saveNotification') {
        if (this.subscribe.ss.access == true || this.subscribe.wic.access == true || this.subscribe.cci.access == true) {
          this.save();
        } else {
          this.bAppService.openSnackBar("Please select atleast one dashboard.");
        }

      }
    });
    this.pubsub.$pub('tabListner', [{ id: 'routeSaveButton', buttonName: 'save', event: 'saveNot', eventAction: 'saveNotification', title: 'Save' }]);
    if (this.mulNotify.dashboardObject && this.mulNotify.dashboardObject.dashboard) {
      // removing object reference assignment
      this.subscribe = JSON.parse(JSON.stringify(this.mulNotify.dashboardObject.dashboard));
      // this.subscribe = this.mulNotify.dashboardObject.dashboard;
    }

  }

  ngDoCheck() {
    if (this.subscribe) {
      if ((this.subscribe.ss && !this.subscribe.ss.access)) {
        this.subscribe.ss.channels['high'] = false;
        this.subscribe.ss.channels['medium'] = false;
        this.subscribe.ss.channels['low'] = false;
      }
      if ((this.subscribe.wic && !this.subscribe.wic.access)) {
        this.subscribe.wic.channels['high'] = false;
        this.subscribe.wic.channels['medium'] = false;
        this.subscribe.wic.channels['low'] = false;
      }
      if ((this.subscribe.cci && !this.subscribe.cci.access)) {
        this.subscribe.cci.channels['high'] = false;
        this.subscribe.cci.channels['medium'] = false;
        this.subscribe.cci.channels['low'] = false;
      }
    }
  }

  save() {
    // this.pubsub.$pub('dashBoadrd', "result");
    this.mulNotify.updateDashboards(this.subscribe).then(result => {
      if (Object.keys(result).length > 0) {
        // this.pubsub.$pub('dashBoadrd', result);
      }
    }).catch(error => {
      console.error(error);
    })
  }

  ngOnDestroy() {
    this.actionBarSub.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/notificationComponent/notification.component.ts